module.exports = __webpack_public_path__ + "img/proften.b6ff9a09.png";